export interface MenuItem {
  _id?: number;
  moduleName?: string;
  moduleKey?: string;
  icon?: string;
  link?: string;
  submodules?: any;
  isTitle?: boolean;
  badge?: any;
  parentId?: number;
  isLayout?: boolean;
}
export interface ModuleData {
  _id?: string;
  moduleName?: string;
  icon?: string;
  link?: string;
  badge?: string;
  isSubModule?: boolean;
  submodules?: string[];
}
